import { render, staticRenderFns } from "./SubscriptionFilter.vue?vue&type=template&id=49e980a8&scoped=true&"
import script from "./SubscriptionFilter.vue?vue&type=script&lang=js&"
export * from "./SubscriptionFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e980a8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/paywall/subscription/SubscriptionFilter.vue
// module id = 568
// module chunks = 0